import { jsx } from 'react/jsx-runtime';

const TooltipIcon = (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", children: jsx("g", { fill: "#717E8F", children: jsx("g", { children: jsx("path", { d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 5c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1s-1-.448-1-1V8c0-.552.448-1 1-1zm0-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z", transform: "translate(-296 -238) translate(296 238)" }) }) }) }));

export { TooltipIcon };
//# sourceMappingURL=TooltipIcon.js.map
